<template>
  <div class="card" style="border: none">
    <div class="painel-body">
      <div class="painel-page">
        <!-- Header -->
        <div
          id="headingOne"
          class="cabecalhoDependente p-3"
          data-bs-toggle="collapse"
          aria-expanded="true"
          :data-bs-target="'#expansion-panel-' + id"
          :aria-controls="id"
        >
          <slot name="header"></slot>
        </div>

        <!-- Body -->
        <div :id="'expansion-panel-' + id" class="collapse show" data-parent="#accordion">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
  data() {
    return {
      id: uuidv4(),
    };
  },
  created() {
    this.id = uuidv4();
  },
});
</script>
